export default __webpack_public_path__ + "static/media/startupRealCase1.dbf734dd.jpg";